<script lang="ts">
  import type { IconName } from '@/ui/base';

  //import { useTeoContext } from '@/utils/teo-context';

  import SmallGhostButton, { type SmallGhostButtonProps } from './SmallGhostButton.svelte';

  export type HelpTargetProps = {
    topic: string;
    section?: string;
    content?: string;
  };

  let {
    icon = 'InfoOutline',
    topic = 'help',
    section,
    content,
    ...props
  }: Omit<SmallGhostButtonProps, 'icon'> & HelpTargetProps & { icon?: IconName } = $props();

  // TODO: Implement teoCore to Storybook (decorators)
  //let tcx = useTeoContext();
</script>

<SmallGhostButton
  {icon}
  {...props}
  onclick={() => {
    window.__TEO__getCore().help.open({
      topic,
      section,
      content,
    });
    // executeActionString(core, '#teo:help/TOPIC/SECTION/CONTENT');
  }}
/>
